import {DomainStore} from 'shared/store';
import { makeAutoObservable } from 'mobx';
import {api} from 'shared/core';
import {endpoints} from 'main/tools';

class SetupState {
  store = new DomainStore();

  constructor() {
    makeAutoObservable(this, {
      store: false
    });
  }

  async setup() {
    const {status} = await api.post(
      endpoints.NMBR.SETUP
    );

    if (status === 201) {
      window.location = '/payroll';
    }
  }
}

export default SetupState;
